module.exports = __webpack_public_path__ + "img/icon-profile.0e5b40db.svg";